import { graphql } from '@/generated/gql';

export const UPDATE_SAVING_MUTATION = graphql(/* GraphQL */ `
  mutation UpdateSaving($id: ID!, $input: SavingInput!) {
    updateSaving(id: $id, input: $input) {
      id
      name
      description
      status
      savingType
      currency
      baselinePrice
      newPrice
      baselineQuantity
      newQuantity
      validFrom
      validTo
      createdAt
      updatedAt
      fkBuyer
      fkSupplier
      fkCommodityGroup
      freeTextCommodity
      fkProcurementOrganization
      fkOrganization
      fkPurchasingGroup
      fkAccountingArea
      fkUnit
      originalPriceQuantity
      newPriceQuantity
      reductionType
      costAllocation {
        distributionType
        allocationValue
        fkAccountAssignmentCategory
        fkAccountAssignment
        fkGeneralLedgerAccount
      }
      sourceReferences {
        fkSourceSystem
        isPrimary
        sourceContext
        sourceReference
        sourceReferenceItem
        synchronizedAt
      }
    }
  }
`);
